/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router, UrlSerializer } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { Hub } from '@aws-amplify/core';
import { AuthService } from './auth/auth.service';
import { Auth } from '@aws-amplify/auth';

@Component({
  selector: 'ngx-app',
  // template: '<amplify-authenticator><router-outlet></router-outlet></amplify-authenticator>',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  entryNavigationUrl: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    private logger: NGXLogger,
    private us: UrlSerializer,
  ) {
    this.initAuth();
  }

  ngOnInit() {
  }

  async initAuth() {
    // take only 1st event from router event stream and complete the stream
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationStart),
        take(1),
      )
      .subscribe((event: NavigationStart) => {
        this.logger.debug('app.component - NavigationStart: ', event);
        this.entryNavigationUrl = '';
      });

    // init Hub
    Hub.listen('auth', ({ payload: { event, data, message } }) => {
      this.logger.debug('app.component - auth payload: ', { event, data, message });
      switch (event) {
        case 'signIn':
          this.initIdleService();
          break;
        case 'signOut':
          this.entryNavigationUrl = '';
          // this.router.navigate(['/auth']);
          window.location.reload();
          break;
        case 'customOAuthState':
          try {
            const { bhref } = JSON.parse(data);
            if (bhref) {
              // window.location.replace(environment.siteUrl + bhref);
            }
          } catch (err) {}
          break;
      }
    });
    Auth.currentAuthenticatedUser()
      .then(_ => {
        this.initIdleService();
      })
      .catch(err => this.logger.warn(err));
  }


  initIdleService() {
    const APP_SESSION_TIMEOUT_IN_SECONDS = 43200;
    const APP_SESSION_TIMEOUT_WARNING_IN_SECONDS = 42000;
    this.authService.initIdleService({
      timeoutDuration: APP_SESSION_TIMEOUT_IN_SECONDS,
      timeoutWarningDuration: APP_SESSION_TIMEOUT_WARNING_IN_SECONDS,
    });
  }

  private parseContinueUrl() {
    const returnUrl = this.entryNavigationUrl || this.router.url;
    const tree = this.us.parse(returnUrl);
    const continueParam = tree.queryParamMap.get('continue');

    return continueParam ? continueParam : returnUrl;
  }
}
